import { useEffect, useState } from "react";
import { Container, AllManageStateContainer, Cart } from "./style";
import Button from "components/particles/primary-button";
import NoDataFound from "components/particles/no-data-found";
import { useSessionPrerequisites } from "./useHook";
import { useSelector } from "react-redux";
import { dispatch, RootState } from "store";
import { setModalOpened } from "store/user-slice";
import AddSessionPrerequisitePopup from "components/popus/Settings/session-prerequisite";
import { FaFilePdf } from "react-icons/fa";

export default function SessionPrerequisite() {
  const [data, setData] = useState<any[]>([]);
  const [dataById, setDataById] = useState<any>();
  const [id, setId] = useState<number>(0);
  const { getSessionPrerequisites, getSessionPrerequisiteById } =
    useSessionPrerequisites();
  const { sessionPrerequisiteModalIsOpen, isLoading } = useSelector(
    (state: RootState) => state.user
  );

  useEffect(() => {
    getSessionPrerequisites(setData, () => { }, 0, 100);
  }, []);

  // Refresh data when modal closes
  useEffect(() => {
    if (!sessionPrerequisiteModalIsOpen) {
      const timer = setTimeout(() => {
        getSessionPrerequisites(setData, () => { }, 0, 100);
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [sessionPrerequisiteModalIsOpen]);

  const handlePopup = async (id: number) => {
    setId(id);
    if (id !== 0) {
      await getSessionPrerequisiteById(id, setDataById);
    } else {
      setDataById(null);
    }
    dispatch(setModalOpened("Session Prerequisite"));
  };

  const formatDate = (dateString: string) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const maxItemAllowed = 1;

  return (
    <Container>
      <div className="title">
        <h1>Session Prerequisite Management</h1>
        {data?.length >= maxItemAllowed ? null : (
          <Button
            title="Add Session Prerequisite"
            width="22rem"
            fill="true"
            backgroundcolor="var(--secondary)"
            onclick={() => handlePopup(0)}
          />
        )}
      </div>

      <AllManageStateContainer>
        {data?.length > 0 ? (
          data.map((item, index) => (
            <Cart key={index}>
              <div className="banner-img-title">
                <div className="document-preview-container">
                  {item?.document_link && item.document_link.length > 0 && item.document_link[0] ? (
                    <div className="document-item">
                      <div className="document-icon-wrapper">
                        <FaFilePdf className="document-icon" />
                      </div>
                      <button
                        className="preview-button"
                        onClick={() => window.open(item.document_link[0], "_blank", "noopener,noreferrer")}
                      >
                        Preview
                      </button>
                    </div>
                  ) : (
                    <div className="no-preview">
                      <span>No documents</span>
                    </div>
                  )}
                </div>
                <div className="banner-title">
                  <div style={{ display: "flex", gap: "1rem" }}>
                    <span>Created At:</span>
                    <h1>{formatDate(item?.createdAt)}</h1>
                  </div>
                  <div className="document-links">
                    {item?.document_link && item.document_link.length > 0 && item.document_link[0] ? (
                      <p
                        style={{ fontSize: "1.6rem", fontWeight: "500", color: "var(--text)" }}
                      >
                        Cooking Session Setup Document
                      </p>
                    ) : (
                      <span>-</span>
                    )}
                    <p style={{ fontSize: "1.6rem", fontWeight: "500", color: "var(--text)" }}>
                      {item?.filename && item.filename.length > 0 ? item.filename[0] : "-"}
                    </p>
                  </div>
                </div>
              </div>
              <Button
                title="Update"
                width="11.2rem"
                fill="true"
                onclick={() => handlePopup(item?.id)}
                backgroundcolor="var(--secondary)"
              />
            </Cart>
          ))
        ) : (
          <NoDataFound isShow={!isLoading} />
        )}
      </AllManageStateContainer>

      {sessionPrerequisiteModalIsOpen ? (
        <AddSessionPrerequisitePopup
          id={id}
          data={dataById}
          refreshData={() => getSessionPrerequisites(setData, () => { }, 0, 100)}
        />
      ) : (
        ""
      )}
    </Container>
  );
}

